import { tryOrCatchMessageError } from '@/utils/tryOrCatchMessageError';
import { useCallback, useState } from 'react';

export interface UseRequestDeleteOptions<Response, Id> {
  request: (id: Id, companyId?: string) => Promise<Response> | Response;
  externalLoading?: boolean;
  callback?: (response: Response, id: Id, companyId?: string) => Response;
}

export const useRequestDeletion = <Response = void, Id = string | number>({
  request,
  externalLoading,
  callback,
}: UseRequestDeleteOptions<Response, Id>) => {
  const [loading, setLoading] = useState(false);

  const requestDeletion = useCallback(
    async (id: Id, companyIdToCreate?: string) => {
      if (externalLoading) {
        return;
      }

      await tryOrCatchMessageError(
        async () => {
          const response = await request(id, companyIdToCreate);
          callback?.(response, id, companyIdToCreate);
        },
        {
          tryBefore: () => setLoading(true),
          tryAfter: () => setLoading(false),
          messageErrorDefault: 'A solicitação de deleção falhou, tente novamente mais tarde.',
        },
      );
    },
    [externalLoading, request, callback],
  );

  return {
    requestDeletion,
    loading,
  };
};
